import { Box } from "@mui/material";

import { withForm } from "components/Forms/AppForm";

import { pcmFormDefaultValues } from "./pcmFormDefaultValues";

const AdditionalInfoSection = withForm({
  defaultValues: pcmFormDefaultValues,
  render: function Render({ form }) {
    return (
      <Box sx={{ mb: 4 }}>
        <form.AppField name="additionalInformation">
          {(field) => (
            <field.TextInput
              label="Additional Information"
              multiline
              rows={5}
            />
          )}
        </form.AppField>
      </Box>
    );
  },
});

export default AdditionalInfoSection;
